<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <tabs @setTab="setTab"></tabs>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form @input="checkTabAwailability()"
                    @mousedown="checkTabAwailability()" v-on:submit.prevent="addItem">
                <transition-group name="modal-fields" mode="out-in">
                  <div v-show="!isLastTab" class="modal-tab-section" key="1">
                    <form-input name="title"></form-input>
                    <form-file use-case="cover" name="img"></form-file>
                    <form-text-area name="subtext"></form-text-area>
                    <form-input name="mail"></form-input>
                    <form-input name="facebook"></form-input>
                    <form-input name="vk"></form-input>
                    <form-input name="youTube"></form-input>
                    <form-input name="liveJournal"></form-input>
                    <form-input name="ok"></form-input>
                    <form-input name="skype"></form-input>
                    <form-text-editor name="text" editor-id="editor"></form-text-editor>
                  </div>
                  <div v-show="isLastTab" class="modal-tab-section" key="2">
                    <form-input name="seo_title"></form-input>
                    <form-text-area name="seo_key"></form-text-area>
                    <form-text-area name="seo_desc"></form-text-area>
                  </div>
                </transition-group>
              </form>
            </div>
          </div>
          <div class="buttons">
            <button class="back" v-if="isLastTab" @click="onPrev"><span><icon-arrowbold
              class="icon-arrowbold left"/></span>Назад
            </button>
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" v-if="!isLastTab" @click="nextTab">Перейти далее
                <icon-arrowbold class="icon-arrowbold right"/>
              </button>
              <button class="confirm" v-else @click="onAddItem">{{textContent.submitButton}}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import Calendar from '@/components/create-form/Calendar'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from "@/components/create-form/Checkbox";

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data() {
      return {
        showed: false,
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls() {
        return this.$store.state.apiUrls
      },
      parentId() {
        return this.$store.state.parentId
      }
    },
    methods: {
      nextTab() {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.onNext()
      },
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem() {
        //this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        //this.fields.text.editor.setData('');
        this.addItem()
      },
      setTab() {
        if (this.isLastTab)
          this.$store.dispatch('mainPage/onPrev')
        else
          this.$store.dispatch('mainPage/onNext')
      },
      closeModal() {
        this.showed = false;
      }
    },
    mounted() {
      this.showed = true;
      this.checkTabAwailability()
    },
    created() {
      this.setTabs([
        {title: 'Общие настройки', isFilledIn: false, icon: 'alignleft', styleClass: 'first'},
        {title: 'SEO', isFilledIn: false, icon: 'signalbars', styleClass: 'second'}
      ])
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Имя эксперта',
          errorId: null,
          errors: {empty: 'Введите название семинара'},
          tabId: 0
        },
        mail: {
          value: '',
          parameterName: 'mail',
          name: 'Email',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        facebook: {
          value: '',
          parameterName: 'facebook',
          name: 'Facebook',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        vk: {
          value: '',
          parameterName: 'vk',
          name: 'Вконтакте',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        youTube: {
          value: '',
          parameterName: 'youTube',
          name: 'YouTube',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        liveJournal: {
          value: '',
          parameterName: 'liveJournal',
          name: 'Live Journal',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        ok: {
          value: '',
          parameterName: 'ok',
          name: 'Одноклассники',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        skype: {
          value: '',
          parameterName: 'skype',
          name: 'Skype',
          errorId: null,
          type: 'object',
          isNullable: true,
          tabId: 0
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          isNullable: true,
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите название страницы'},
          tabId: 1
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 1
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 1
        },
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs,
      Calendar
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/feedbacks/CreateModal.vue